import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import ModalTitle from 'react-bootstrap/ModalTitle'

const ProjectWarnings = (props) => {
  const [show, setShow] = useState(false)

  useEffect(() => setShow(props.projectWarnings != null && props.projectWarnings.length > 0))
  if (!props.projectWarnings) return null;

  const onContinue = () => {
    props.onCloseWarnings()
    jQuery('#quote_form').submit()
  }

  return (
    <Modal show={show} onHide={props.onCloseWarnings}>
      <Modal.Header closeButton>
        <ModalTitle id="modal-project-header">
          Warning
        </ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled">
          {props.projectWarnings.map((err, idx) => (
            <li key={idx}>{err}</li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={props.onCloseWarnings}>Cancel</button>
        <button type="button" className="btn btn-primary" onClick={onContinue}>Continue</button>
      </Modal.Footer>
    </Modal>
  )
}

export default ProjectWarnings
